import styled from 'styled-components';
import { colors, breakpoints, font, spacing, zindex } from '@chegg-ui/theme';
import { Font } from '../../internals/common/styled/common';
import { Link } from '@chegg-ui/link';
import { visuallyHiddenCss } from '@chegg-ui/theme';
import { LargeTooltip } from '@chegg-ui/tooltip';
var grey200 = colors.grey200,
  grey700 = colors.grey700,
  red700 = colors.red700;
var sm = breakpoints.sm;
export var Header = styled.div.withConfig({
  componentId: "sc-gytxq6-0"
})(["padding:10px;background-color:white;border-bottom:1px solid ", ";&.header-btn{", " cursor:pointer;}&.editHeader{display:flex;align-items:center;span{padding-left:10px;}}"], colors.grey100, Font);
export var CardAnnouncement = styled.span.withConfig({
  componentId: "sc-gytxq6-1"
})(["", ""], visuallyHiddenCss);
export var CardContainer = styled.div.withConfig({
  componentId: "sc-gytxq6-2"
})(["display:flex;align-items:center;justify-content:space-between;> div{white-space:nowrap;}div:not(#pm-payment-form-header){margin-left:8px;@media (max-width:", "){margin-left:3px;}}"], sm.max);
export var FormWrapper = styled.form.withConfig({
  componentId: "sc-gytxq6-3"
})(["", " border:1px solid ", ";min-width:230px;line-height:initial;fieldset{border-width:0px;padding:0 10px;}"], Font, grey200);
FormWrapper.displayName = 'FormWrapper';
export var FormContainer = styled.div.withConfig({
  componentId: "sc-gytxq6-4"
})(["transition:0.2s all;overflow:hidden;visibility:hidden;max-height:0px;position:relative;padding-top:10px;padding-bottom:15px;overflow:inherit;max-height:600px;visibility:visible;"]);
export var Row = styled.div.withConfig({
  componentId: "sc-gytxq6-5"
})(["display:flex;flex-direction:row;justify-content:space-between;& > *{flex:auto;}> :not(:first-child){padding-left:25px;}padding-bottom:", ";"], spacing.px12);
export var FormActions = styled.div.withConfig({
  componentId: "sc-gytxq6-6"
})(["margin-top:10px;"]);
export var MopActionWrapper = styled.div.withConfig({
  componentId: "sc-gytxq6-7"
})(["text-align:right;display:inline-block;width:100%;margin:20px 0 10px;@media (max-width:", "){display:flex;flex-direction:column-reverse;text-align:center;.payment-form-cancel-button{margin-top:", ";}}"], sm.max, spacing.px24);
export var LinkWrapper = styled.span.withConfig({
  componentId: "sc-gytxq6-8"
})(["margin:0 15px;"]);
export var AddPaymentMethodLinkWrapper = styled.div.withConfig({
  componentId: "sc-gytxq6-9"
})(["@media (max-width:", "){text-align:center;}"], sm.max);
export var LinkWithDisabledStyle = styled(Link).withConfig({
  componentId: "sc-gytxq6-10"
})(["", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled && "\n      opacity: 0.5;\n      cursor: default;\n      :hover {\n        text-decoration: none;\n      }\n      :active, :focus {\n        outline: 0;\n        border: none;\n        -moz-outline-style: none;\n      }\n    ";
});
export var PaddedContainer = styled.div.withConfig({
  componentId: "sc-gytxq6-11"
})(["margin-bottom:20px;"]);
export var BlockHeader = styled.h2.withConfig({
  componentId: "sc-gytxq6-12"
})(["", " font-weight:", ";padding:0px;margin:0px;"], Font, font.weight.bold);
export var StyledRequiredFieldsLegend = styled.legend.withConfig({
  componentId: "sc-gytxq6-13"
})(["color:", ";padding-top:", " 0;"], grey700, spacing.px24);
export var InputWrapper = styled.div.withConfig({
  componentId: "sc-gytxq6-14"
})(["& ~ div{z-index:", ";}height:58px;border-bottom:1px solid ", ";"], zindex.layout, function (_ref2) {
  var error = _ref2.error;
  return error ? red700 : grey700;
});
export var CVVContainer = styled.div.withConfig({
  componentId: "sc-gytxq6-15"
})(["display:flex;flex-direction:row;width:315px;height:140px;gap:", ";@media (max-width:", "){flex-direction:column;width:165px;height:285px;gap:", ";}"], spacing.px4, sm.max, spacing.px16);
export var CVVSubcontainer = styled.div.withConfig({
  componentId: "sc-gytxq6-16"
})(["width:150px;height:143px;"]);
export var CVVSubheading = styled.div.withConfig({
  componentId: "sc-gytxq6-17"
})(["width:150px;height:", ";font-size:", ";"], function (_ref3) {
  var height = _ref3.height;
  return height ? height : spacing.px32;
}, font.size.px12);
export var CVVImage = styled.div.withConfig({
  componentId: "sc-gytxq6-18"
})(["width:140px;height:93px;padding-top:", ";"], spacing.px12);
export var StyledLargeTooltip = styled(LargeTooltip).withConfig({
  componentId: "sc-gytxq6-19"
})(["& > div{margin-right:-5px;}"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentForm/styled.js
// module id = 195
// module chunks = 11